/**
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

import webFontLoader from 'webfontloader';

export function loadFonts() {
  webFontLoader.load({
    google: {
      families: ['Poppins:400,500,600,700', 'Barlow:400,500,600,700']
    }
  });
}
